import { CustoProjetoEscopo, CustoProjetoTipo, CustoProjetoCategoria, CustoProjetoStatus, CustoProjetoEventoTipo, } from '../generated/backend-enums.js';
export { CustoProjetoEscopo, CustoProjetoTipo, CustoProjetoCategoria, CustoProjetoStatus, CustoProjetoEventoTipo, };
export const CustoProjetoEscopoMap = {
    [CustoProjetoEscopo.JOB]: 'Job',
    [CustoProjetoEscopo.PLANILHA]: 'Planilha',
    [CustoProjetoEscopo.ITEM]: 'Item',
};
export const CustoProjetoTipoMap = {
    [CustoProjetoTipo.DESPESA_EXTRAORDINARIA]: 'Despesa Extraordinária',
    [CustoProjetoTipo.COMISSAO]: 'Comissão',
};
/** Rótulo curto de cada categoria de despesa extraordinária (usado em selects/detalhe). */
export const CustoProjetoCategoriaMap = {
    [CustoProjetoCategoria.INVESTIMENTO_COMERCIAL]: 'Investimento comercial / concorrência',
    [CustoProjetoCategoria.ERRO_OPERACIONAL]: 'Erro operacional interno',
    [CustoProjetoCategoria.REPOSICAO_FORNECEDOR]: 'Reposição / falha de fornecedor',
    [CustoProjetoCategoria.CORTESIA_CLIENTE]: 'Cortesia ao cliente (mitigação de risco)',
    [CustoProjetoCategoria.MULTA_CONTRATUAL]: 'Multa / penalidade contratual',
};
/** Descrição de apoio de cada categoria — o texto que explica *quando* usar cada uma. */
export const CustoProjetoCategoriaDescricaoMap = {
    [CustoProjetoCategoria.INVESTIMENTO_COMERCIAL]: 'Gasto assumido para ganhar ou defender a conta (desconto embutido, brinde, ação pontual).',
    [CustoProjetoCategoria.ERRO_OPERACIONAL]: 'Retrabalho ou custo gerado por uma falha interna da Hub.',
    [CustoProjetoCategoria.REPOSICAO_FORNECEDOR]: 'Custo para cobrir atraso, defeito ou não entrega de um fornecedor.',
    [CustoProjetoCategoria.CORTESIA_CLIENTE]: 'Algo que a Hub decide pagar pelo cliente para reduzir risco ou atrito na relação.',
    [CustoProjetoCategoria.MULTA_CONTRATUAL]: 'SLA não cumprido, cancelamento ou outra penalidade contratual.',
};
export const CustoProjetoStatusMap = {
    [CustoProjetoStatus.RASCUNHO]: 'Rascunho',
    [CustoProjetoStatus.EM_APROVACAO]: 'Em Aprovação',
    [CustoProjetoStatus.APROVADO]: 'Aprovado',
    [CustoProjetoStatus.REPROVADO]: 'Reprovado',
    [CustoProjetoStatus.CANCELADO]: 'Cancelado',
};
export const CustoProjetoEventoTipoMap = {
    [CustoProjetoEventoTipo.LANCAMENTO]: 'Lançamento',
    [CustoProjetoEventoTipo.ESTORNO]: 'Estorno',
    [CustoProjetoEventoTipo.REAJUSTE]: 'Reajuste de valor',
    [CustoProjetoEventoTipo.ENVIADO_APROVACAO]: 'Enviado para aprovação',
    [CustoProjetoEventoTipo.APROVADO]: 'Aprovado',
    [CustoProjetoEventoTipo.REPROVADO]: 'Reprovado',
    [CustoProjetoEventoTipo.CANCELADO]: 'Cancelado',
    [CustoProjetoEventoTipo.APROVACAO_CANCELADA]: 'Aprovação cancelada',
};
